import {collection} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class ErrorCorrectReportData extends ReportData<ErrorCorrectReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
}
